import { render, staticRenderFns } from "./CrawlLimitProgressBar.vue?vue&type=template&id=3a126f2e&"
import script from "./CrawlLimitProgressBar.vue?vue&type=script&lang=js&"
export * from "./CrawlLimitProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a126f2e')) {
      api.createRecord('3a126f2e', component.options)
    } else {
      api.reload('3a126f2e', component.options)
    }
    module.hot.accept("./CrawlLimitProgressBar.vue?vue&type=template&id=3a126f2e&", function () {
      api.rerender('3a126f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/CrawlLimitProgressBar.vue"
export default component.exports